import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { async } from '@angular/core/testing';

@Injectable({
  providedIn: 'root'
})
export class RateRequestService {
  public baseurl = environment.apiUrl;
  private raterequestApi = "api/RateRequest/";
  private _jsonURL = "assets/localdb/freightratedropdown.json";

  constructor(private http: HttpClient) { }

  MakeRateRequest(data) {
    const url = this.baseurl + this.raterequestApi + 'MakeRateRequest';
    return this.http.post(url, data).pipe();
  }


  AllRateRequestList(page,pagesize,searchfield,status,duration) {
    const url = this.baseurl + this.raterequestApi + 'AllRateRequestList' +'?page=' +page +'&pageSize='+pagesize 
    + '&searchMsg=' + searchfield + '&status=' + status + '&duration=' +  duration ;
    return this.http.get(url).pipe();
  }

  MyRateRequestList(userid,page,pagesize,searchfield,status,duration) {
    const url = this.baseurl + this.raterequestApi + 'MyRateRequestList' +'?userid=' + userid + '&page=' +page +'&pageSize='+pagesize 
    + '&searchMsg=' + searchfield + '&status=' + status + '&duration=' +  duration ;
    return this.http.get(url).pipe();
  }

  GetRateRequest(id) {
    const url = this.baseurl + this.raterequestApi + 'GetRateRequest' +'?id=' + id;
    return this.http.get(url).pipe();
  }
 
  DeleteRateRequest(id) {
    const url = this.baseurl + this.raterequestApi + 'DeleteRateRequest' +'?id=' + id;
    return this.http.get(url).pipe();
  }

  SaveFreightRate(model) {
    const url = this.baseurl + this.raterequestApi + 'SaveOffredFreightRateDetails';
    return this.http.post(url, model).pipe();
  }

  Getofferedratedet(raterequestId,offerdrateid) {
    const url = this.baseurl + this.raterequestApi + 'GetOffredFreightRateDetails' + '?rateReqId=' + raterequestId + '&offerdrateId=' + offerdrateid;
    return this.http.get(url).pipe();
  }

  SavedRerequestComment(ratereqId,comments) {
    const url = this.baseurl + this.raterequestApi + 'RateReRequest' + '?ratereqId=' + ratereqId + '&comments=' + comments;
    return this.http.get(url).pipe();
  }

  GetAllOfferedRatesList(ratereqId,userid) {
    const url = this.baseurl + this.raterequestApi + 'GetAllOfferedRatesList' + '?rateReqId=' + ratereqId + '&userid=' + userid;
    return this.http.get(url).pipe();
  }

  public getRateRequestDropdown(): Observable<any> {
    return this.http.get(this._jsonURL);
  }

  SendBookingRequestEmail(model) {
    const url = this.baseurl + this.raterequestApi + 'SendBookingRequestEmail';
    return this.http.post(url, model).pipe();
  }
  // public getRateRequestDropdown(): Promise<any> {
  //   return this.http.get(this._jsonURL)
  //     .toPromise()
  //     .then(response => response as any)
  //     .catch(this.handleError);
  // }
  // handleError(){
  //   console.log('**');
  // }
}
